(() => {
  'use strict';
  const source = document.getElementById('ra-readable-storefront');
  const main = document.getElementById('MainContent');
  if (!source || !main) return;
  const words = source.dataset;
  let pending = false;
  let dialog;
  let lastReviewButton;
  let titleSignature = '';
  const alignedTitles = new WeakSet();
  function alignTitles() {
    const rows = new Map();
    const parents = new Map();
    const cards = [...main.querySelectorAll('.grid-product')].filter(card => {
      const title = card.querySelector('.grid-product__title');
      return title && card.getBoundingClientRect().width && !card.closest('[hidden],[aria-hidden="true"],template');
    });
    const signature = innerWidth + ':' + cards.map(card => {
      const title = card.querySelector('.grid-product__title');
      return card.dataset.productId + ':' + card.getBoundingClientRect().width + ':' + getComputedStyle(title).fontSize + ':' + title.textContent;
    }).join('|');
    if (signature === titleSignature && cards.every(card => alignedTitles.has(card.querySelector('.grid-product__title')))) return;
    titleSignature = signature;
    cards.forEach(card => card.querySelector('.grid-product__title').style.removeProperty('--ra-readable-title-height'));
    cards.forEach(card => {
      const title = card.querySelector('.grid-product__title');
      if (!parents.has(card.parentElement)) parents.set(card.parentElement, parents.size);
      const key = parents.get(card.parentElement) + ':' + Math.round(card.getBoundingClientRect().top / 3);
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(title);
    });
    rows.forEach(titles => {
      const height = Math.ceil(Math.max(...titles.map(title => title.getBoundingClientRect().height)));
      titles.forEach(title => {
        title.style.setProperty('--ra-readable-title-height', height + 'px');
        alignedTitles.add(title);
      });
    });
  }
  function dimensions() {
    main.querySelectorAll('.swatch--gl[data-ra-size-ready="true"] label[data-ra-original-label]').forEach(label => {
      const raw = label.dataset.raOriginalLabel;
      const group = label.closest('[data-ra-size-unit]');
      if (!group) return;
      const text = raw.replace(/[×✕]/g, 'x').replace(/[“”″]/g, '"');
      const inch = text.match(/(\d+(?:\.\d+)?)\s*(?:"|in)\s*([hw])?\s*x\s*(\d+(?:\.\d+)?)\s*(?:"|in)\s*([hw])?/i);
      const metric = text.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*cm/i);
      if (!inch || !metric || /each|\b[23]\s*p\b/i.test(text)) return;
      const firstAxis = inch[2] ? ' ' + inch[2].toUpperCase() : '';
      const secondAxis = inch[4] ? ' ' + inch[4].toUpperCase() : '';
      const alternate = group.dataset.raSizeUnit === 'cm'
        ? inch[1] + firstAxis + ' × ' + inch[3] + secondAxis + ' in'
        : metric[1] + firstAxis + ' × ' + metric[2] + secondAxis + ' cm';
      let span = label.querySelector('.ra-size-alternate');
      if (!span) {
        span = document.createElement('span');
        span.className = 'ra-size-alternate';
        span.setAttribute('aria-hidden', 'true');
        label.append(span);
      }
      if (span.textContent !== alternate) span.textContent = alternate;
    });
  }
  function makeDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'ra-full-review';
    dialog.setAttribute('aria-labelledby', 'ra-full-review-heading');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'ra-full-review__close';
    close.textContent = words.close;
    close.addEventListener('click', () => dialog.close());
    const heading = document.createElement('h2');
    heading.id = 'ra-full-review-heading';
    heading.textContent = words.reviewHeading;
    const meta = document.createElement('p');
    meta.className = 'ra-full-review__meta';
    const text = document.createElement('div');
    text.className = 'ra-full-review__text';
    dialog.append(close, heading, meta, text);
    dialog.addEventListener('close', () => {
      document.body.classList.remove('ra-full-review-open');
      requestAnimationFrame(() => {
        if (lastReviewButton?.isConnected) lastReviewButton.focus({preventScroll:true});
      });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    document.body.append(dialog);
    return dialog;
  }
  function openReview(card, button) {
    const modal = makeDialog();
    lastReviewButton = button;
    modal.querySelector('.ra-full-review__meta').textContent = [
      card.querySelector('.jdgm-rev__author')?.textContent.trim(),
      card.querySelector('.jdgm-rev__timestamp')?.textContent.trim(),
      card.querySelector('.jdgm-rev__rating')?.getAttribute('aria-label')
    ].filter(Boolean).join(' · ');
    const title = card.querySelector('.jdgm-rev__title')?.textContent.trim();
    const body = card.querySelector('.jdgm-rev__body')?.textContent.trim();
    modal.querySelector('.ra-full-review__text').textContent = [title, body].filter(Boolean).join('\n\n');
    modal.querySelectorAll('.ra-full-review__photo').forEach(photo => photo.remove());
    card.querySelectorAll('.ra-review-photo a').forEach(link => {
      const original = link.querySelector('img');
      const url = link.getAttribute('href');
      if (!original || !url || !/^https?:\/\//.test(url)) return;
      const photo = document.createElement('a');
      photo.className = 'ra-full-review__photo';
      photo.href = url;
      photo.target = '_blank';
      photo.rel = 'noopener';
      const image = document.createElement('img');
      image.src = original.currentSrc || original.src;
      image.alt = original.alt;
      image.loading = 'lazy';
      photo.append(image);
      modal.append(photo);
    });
    document.body.classList.add('ra-full-review-open');
    modal.showModal();
  }
  function reviews() {
    if (!('HTMLDialogElement' in window)) return;
    main.querySelectorAll('#ra-product-reviews .ra-review-stream-grid>.jdgm-rev,#ra-product-reviews .jdgm-rev-widg__reviews>.jdgm-rev').forEach(card => {
      if (card.hasAttribute('data-ra-readable-review')) return;
      const content = card.querySelector('.jdgm-rev__content');
      const body = card.querySelector('.jdgm-rev__body');
      if (!content || !body?.textContent.trim()) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ra-review-read-more';
      button.textContent = words.readReview;
      button.setAttribute('aria-haspopup', 'dialog');
      content.append(button);
      content.removeAttribute('tabindex');
      content.removeAttribute('aria-label');
      card.setAttribute('data-ra-readable-review', 'true');
    });
  }
  function navigation() {
    const room = main.querySelector('.shopify-section[id$="__image-grid"]');
    const size = main.querySelector('.shopify-section[id$="__image_compare_qEkR9z"]');
    const intro = main.querySelector('.shopify-section[id$="__ra_value_props"] .rte');
    if (room && intro && !main.querySelector('.ra-readable-room-jump')) {
      const nav = document.createElement('nav');
      nav.className = 'ra-readable-room-jump';
      nav.setAttribute('aria-label', words.roomLabel);
      [[room, words.roomLabel],[size, words.sizeLabel]].forEach(([target,label]) => {
        if (!target) return;
        target.setAttribute('data-ra-room-examples', '');
        const link = document.createElement('a');
        link.href = '#' + target.id;
        link.textContent = label;
        nav.append(link);
      });
      intro.after(nav);
    }
    const examples = main.querySelector('[data-ra-detail-compact] [data-ra-carousel="frames"]');
    const images = main.querySelector('[data-product-images]');
    if (examples && images && !main.querySelector('.ra-room-photos-link')) {
      examples.id ||= 'ra-room-photo-examples';
      examples.setAttribute('data-ra-room-examples', '');
      const link = document.createElement('a');
      link.className = 'ra-room-photos-link';
      link.href = '#' + examples.id;
      link.textContent = words.roomPhotos;
      images.after(link);
    }
  }
  function update() {
    pending = false;
    dimensions();
    reviews();
    navigation();
    alignTitles();
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes' || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.grid-product,.jdgm-rev,.swatch--gl,[data-ra-detail-compact]') || node.querySelector('.grid-product,.jdgm-rev,.swatch--gl'))))) schedule();
  });
  if (!document.body.classList.contains('template-index')) {
    observer.observe(main, {subtree:true,childList:true,attributes:true,attributeFilter:['hidden','data-ra-size-unit']});
  }
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  main.addEventListener('click', event => {
    const button = event.target.closest('.ra-review-read-more');
    if (button) {
      const card = button.closest('.jdgm-rev');
      if (card) {
        event.preventDefault();
        event.stopPropagation();
        openReview(card, button);
      }
    }
    if (event.target.closest('[role="tab"],.ra-size-unit-toggle')) schedule();
  }, true);
  if (document.fonts) document.fonts.ready.then(schedule);
  schedule();
})();
